const GallerysBgColorsData = [
    {
        id: 2,
        gallerybgcolor: "#DDB967",
        dramascolor: "#DDB967",
        videoscolor: "#EBD7CF",
        eventsGallerycolor: "#DDB967",
    },
    {
        id: 3,
        gallerybgcolor: "#2F54CC",
        dramascolor: "#23B5D3",
        videoscolor: "#D2BFDB",
        eventsGallerycolor: "#2FCC6E",
    },
    {
        id: 4,
        gallerybgcolor: "#FA5738",
        dramascolor: "#2F54CC",
        videoscolor: "#B2E6C7",
        eventsGallerycolor: "#2F54CC",
    },
    {
        id: 5,
        gallerybgcolor: "#2FCC6E",
        dramascolor: "#FC7336",
        videoscolor: "#B2D1E6",
        eventsGallerycolor: "#FA5738",
    },
    {
        id: 6,
        gallerybgcolor: "#A91794",
        dramascolor: "#2FCC6E",
        videoscolor: "#FBF6B2",
        eventsGallerycolor: "#A91794",
    },
];
export default GallerysBgColorsData;